import React, {useState} from "react";
import { useControles } from "../../context/controles.context";
import { PrimaryLabel, PrimaryTextInput, PrimaryButton, Logo1, ErrorMsg, } from "../../globalComponents";
import {
    StyledDiv,
    PageWrapper,
    FormsContainer,
    Forms,
    ForgotPassword,
    StyledDivDesktop,
    PageWrapperDesktop
} from "./styles";


import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/auth.context";
import { useWhitelabel } from "../../context/whitelabel.context";
import LoadingMain from "../Loadings/LoadingMain";
import { useEffect } from "react";
import { LoginUsuario } from "../../services/plataforma";
import { setStoredAuthData } from "../../utils/authStorage";

const resolveVerifiedUser = (payload) => {
    const candidates = [payload, payload?.data, payload?.user, payload?.data?.user]

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object') {
            continue
        }

        const value = candidate.verifiedUser

        if (typeof value === 'boolean') {
            return value
        }

        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase()
            if (normalized === 'true') {
                return true
            }

            if (normalized === 'false') {
                return false
            }
        }
    }

    return null
}

const resolveIsAdmin = (payload) => {
    const candidates = [payload, payload?.data, payload?.user, payload?.data?.user]

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object') {
            continue
        }

        const value = candidate.isAdmin

        if (typeof value === 'boolean') {
            return value
        }

        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase()
            if (normalized === 'true') {
                return true
            }

            if (normalized === 'false') {
                return false
            }
        }
    }

    return false
}


const CardLogin = () => {
    const {isMobile, errorMsg, setErrorMsg, setIsLoading} = useControles()
    const {
        Login,
        statusWizard,
        GetBoolWizard,
        setAuthStatus,
        authStatus,
        AtualizarToken,
        setNewToken,
        newToken,
        setVerifiedUser,
        setIsAdmin,
        ClearAdminAccessMode
    } = useAuth()
    const {clienteId, primaryBackgroundHex, logoVertical, linkCadastro, sloganLogin} = useWhitelabel()
    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [isLoadingLogin, setIsLoadingLogin] = useState(false)

    const [tokenValido, setTokenValido] = useState()
    const loginSloganText = String(sloganLogin || '').trim() || 'Estamos te esperando para mais uma rodada!'

    const handleKeyPress = (event) => {

        if (event.key === 'Enter' || event.code === 'Enter') {
            handleLogin();
        }
    }



    const handleLogin = async () => {
        if(!email){
            setErrorMsg("Insira seu username.")
        } else if (!senha){
            setErrorMsg("Insira sua senha.")
        } else {
            setErrorMsg(null)
            const userData = {
                id: 0,
                nome: '',
                email: email,
                senha: senha,
                clienteId: clienteId,
                username: email
            }
            setIsLoading(true)
            setIsLoadingLogin(true)

            await LoginUsuario({
                username: email,
                password: senha
            }).then(async (res)=>{
                console.log("Res: ", res)
                const responseData = res?.data?.data || res?.data
                const responseToken =
                    responseData?.token ||
                    responseData?.accessToken ||
                    res?.data?.token ||
                    res?.data?.accessToken ||
                    res?.data?.data?.token ||
                    res?.data?.data?.accessToken

                if(!responseData){
                    setErrorMsg("Nao foi possivel concluir o login. Tente novamente.")
                    setIsLoading(false)
                    setAuthStatus(false)
                    setIsLoadingLogin(false)
                    return
                }

                if(responseData.message){
                    setErrorMsg("Usuario ou senha incorretos.")
                    setIsLoading(false)
                    setAuthStatus(false)
                    setIsLoadingLogin(false)
                    return
                } else if(!responseToken){
                    setErrorMsg("Token de acesso nao retornado pelo login.")
                    setIsLoading(false)
                    setAuthStatus(false)
                    setIsLoadingLogin(false)
                    return
                } else {
                    const verifiedStatus = resolveVerifiedUser(res?.data)
                    const isAdminUser = resolveIsAdmin(res?.data)

                    setAuthStatus(true)
                    setVerifiedUser(verifiedStatus === null ? true : verifiedStatus)
                    setIsAdmin(isAdminUser)

                    // Forca o admin a escolher entre site e painel a cada novo login.
                    ClearAdminAccessMode()

                    setIsLoading(false)
                    setIsLoadingLogin(false)
                    setTokenValido(responseToken)
                    setStoredAuthData(res?.data, responseToken)
                    localStorage.setItem('horarioLogin', new Date().getTime())
                    setNewToken(responseToken)
                }

            }).catch((err) => {
                setIsLoading(false)
                setAuthStatus(false)
                setIsLoadingLogin(false)

                console.log("Error: ", err)
                setErrorMsg("Usuario ou senha incorretos.")
            })

        }

    }
    useEffect(()=>{
        if(authStatus){
            if(statusWizard == '1' || statusWizard == 1){
                navigate('/wizard')
                setAuthStatus(true)
            } else {
                navigate('/')
                setAuthStatus(true)
            }
        }

    }, [statusWizard])

    const handleRegistro = () => {
        window.open(linkCadastro, 'blank')
    }

    const handleGoToRegisterPage = () => {
        navigate('/Register')
    }

    return (
        <>
            {isMobile ?
                <>
                <StyledDiv>
                    <PageWrapper>

                        <img src={logoVertical} style={{width: '100%', height: '100%', maxWidth: 150, maxHeight: 150}}/>

                        <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 0, paddingBottom: 30,}}>
                            <h1 style={{fontSize: 36}}>Bem vindo!</h1>
                            <p>Entre para continuar</p>
                        </div>

                        <FormsContainer>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <span style={{color: 'white', display: 'flex', alignItems: 'center', fontSize: '18px', textAlign: 'center'}}>
                                    Faça o login e aproveite nosso APP
                                </span>
                                
                            </div>
                            <Forms className="form-login">
                                <div>
                                    <PrimaryLabel>Username</PrimaryLabel>
                                    <PrimaryTextInput placeholder="Informe seu username"
                                    value={email} onChange={(e)=>setEmail(e.target.value)} onKeyDown={handleKeyPress}/>
                                </div>

                                <div>
                                    <PrimaryLabel>Senha</PrimaryLabel>
                                    <PrimaryTextInput placeholder="Informe sua senha" type="password"
                                    value={senha} onChange={(e)=>setSenha(e.target.value)}
                                    onKeyDown={handleKeyPress}/>
                                </div>
                                <ForgotPassword onClick={()=>{
                                    // navigate('/ForgotPassword')
                                    handleRegistro()
                                }}>
                                    Esqueceu sua senha?
                                </ForgotPassword>
                            </Forms>

                            {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}

                            <div style={{paddingTop: 20, display: 'flex', flexDirection: 'column', gap: 30,}}>

                                <PrimaryButton onClick={handleLogin}>Entrar</PrimaryButton>

                                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,}}>
                                    <p>Caso não tenha uma conta, </p>
                                        <span onClick={()=>{
                                            handleGoToRegisterPage()
                                        }}>  faça seu cadastro!</span>
                                </div>


                            </div>



                        </FormsContainer>
                    </PageWrapper>
                </StyledDiv>
                </> :
                <>
                <StyledDivDesktop>
                    <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',    height: '100%' ,backgroundImage: 'var(--Background-image)', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
                        <img src={logoVertical} style={{width: '100%', height: '100%', maxWidth: 200, maxHeight: 200}}/>
                    </div>

                    <PageWrapperDesktop>



                        <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 10, paddingBottom: 30,}}>
                            <h1 style={{fontSize: 30, textAlign: 'left', maxWidth: '420px'}}>
                                {loginSloganText}
                            </h1>

                            <p style={{textAlign: 'left'}}>Insira seus dados e comece a diversão!</p>
                        </div>

                        <FormsContainer>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <span style={{color: 'white', display: 'flex', alignItems: 'center', fontSize: '18px', textAlign: 'center'}}>
                                    Faça o login e aproveite nosso APP
                                </span>
                                
                            </div>
                            <Forms className="form-login">
                                <div onKeyDown={handleKeyPress}>
                                    <PrimaryLabel>Username</PrimaryLabel>
                                    <PrimaryTextInput placeholder="Informe seu username"
                                    value={email} onChange={(e)=>setEmail(e.target.value)}
                                    onKeyDownCapture={handleKeyPress}/>
                                </div>

                                <div>
                                    <PrimaryLabel>Senha</PrimaryLabel>
                                    <PrimaryTextInput placeholder="Informe sua senha" type="password"
                                    value={senha} onChange={(e)=>setSenha(e.target.value)} onKeyDown={handleKeyPress}/>
                                </div>
                                <ForgotPassword onClick={()=>{
                                    // navigate('/ForgotPassword')
                                    handleRegistro()
                                }}>
                                    Esqueceu sua senha?
                                </ForgotPassword>
                            </Forms>

                            {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}


                            <div style={{paddingTop: 20, display: 'flex', flexDirection: 'column', gap: 30,}}>
                                <PrimaryButton onClick={handleLogin}>Entrar</PrimaryButton>

                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5,}}>
                                    <p>Caso não tenha uma conta, </p>
                                        <span onClick={()=>{
                                            handleGoToRegisterPage()
                                        }}>  faça seu cadastro!</span>
                                </div>


                            </div>



                        </FormsContainer>
                    </PageWrapperDesktop>
                </StyledDivDesktop>
                </>
            }
            {isLoadingLogin &&
                <div style={{position: 'absolute', top: '0%', left: '0%', background: '#00000066', width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{position: 'absolute', top: '45%'}}>
                        <LoadingMain/>
                    </div>
                </div>
            }
        </>
    )
}

export default CardLogin
